define('core/views/ImageRichMediaView',[
    'core/views/RichMediaView',
    'core/utils',
    'core/config',
    'core/mediaConfig',
    'core/templates/postMediaImage',
], function (
    RichMediaView,
    utils,
    config,
    mediaConfig,
    postMediaImageTemplate
) {
    'use strict';

    // regex that will match main Disqus CDN domain -- i.e., 'disquscdn.com' --
    // at end of string: domainMatchesDisqusCDN.test('a.disquscdn.com') -> true
    var domainMatchesDisqusCDN = new RegExp(
        // prevent matching e.g., evil-disquscdn.com
        // by requiring the disquscdn.com part to be
        // preceded either by the string start (e.g. 'disquscdn.com')
        // or a dot '.' (e.g., '.disquscdn.com')
        '(^|\\.)'

        // take only the last two parts, ignore subdomains --
        // e.g. 'a.disquscdn.com' -> 'disquscdn\.com'
        + utils.getDomain(config.urls.media)
            .split('.').slice(-2).join('\\.')

        // only match at end of string
        + '$'
    );

    return RichMediaView.extend({
        // ImageRichMediaView displays the image within a link to the source.
        // The thumbnail url is used for the inline img.

        getMediaDimensions: function () {
            return {
                width: this.media.get('thumbnailWidth'),
                height: this.media.get('thumbnailHeight'),
            };
        },

        getImageUrl: function () {
            return this.media.get('resolvedUrlRedirect') ||
                this.media.get('urlRedirect') ||
                this.media.get('thumbnailUrl');
        },

        getImageThumbnailUrl: function () {
            var url = this.media.get('thumbnailUrl');

            // If this url is on the disqus cdn, request it to be resized.
            // This will apply to both uploaded and linked images.
            // Linked images are proxied via our cdn to support this feature
            // (as well as for several other benefits; see RichMedia property
            // signed_thumbnail_url in rDISQUS for further information).
            if (this.constructor.isOnDisqusCDN(url)) {
                url = utils.serialize(url, {
                    // Use loadedThumbnailWidth to allow server to maintain only
                    // a few different sizes of the image.
                    'w': mediaConfig.get('loadedThumbnailWidth'),
                    'h': this.model.get('deferredHeight'),
                });
            }

            return url;
        },

        generateContentHtml: function () {
            return postMediaImageTemplate({
                model: this.model.toJSON(),
                media: this.media.toJSON(),
                thumbnailUrl: this.getImageThumbnailUrl(),
                imageUrl: this.getImageUrl(),
            });
        },

        prepareElementEvents: function ($node) {
            var self = this;
            var $img = $node.find('img');

            $img.on('load.richMediaView error.richMediaView', function (evt) {
                self.trigger(evt.type);
                $img.off('.richMediaView');
            });
        },

        calculateDeferredHeight: function () {
            // To avoid upscaling, return the smaller of the calculated
            // height and the media height

            var deferredHeight = Math.floor(RichMediaView.prototype.calculateDeferredHeight.apply(this, arguments));
            var mediaHeight = this.getMediaDimensions().height;

            return Math.min(mediaHeight, deferredHeight) || null;
        },
    }, {
        /**
         * Checks if url is on the main Disqus CDN domain, i.e.: disquscdn.com
         * @param  {string}  url the image url to check
         * @returns {boolean}     does the image live on Disqus CDN?
         */
        isOnDisqusCDN: function (url) {
            var urlDomain = utils.getDomain(url);
            return domainMatchesDisqusCDN.test(urlDomain);
        },
    });
});

